import { ReactNode } from "react";
import { Link, useParams } from "react-router-dom";
import { UpdateDepartmentMutation } from "src/api/Department";
import { apiClient } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import { updateDepartmentVariables } from "types/code-generator";

interface Props {
  to: string;
  children: ReactNode;
  title: string;
  icon?: ReactNode;
  department?: boolean;
}

export function SettingsButton(props: Props) {
  const store = useStore();
  const match = useParams<{ departmentId: string }>();
  const department = store.organization.departments.find((d) => {
    if (match.departmentId) {
      return d.id === match.departmentId;
    } else if (props.department) {
      return d.title === props.title;
    } else {
      return d.default;
    }
  });
  let hasViewed = department?.settingOnboards?.includes(props.title);

  if (props.department) {
    hasViewed = department?.settingOnboards?.length >= 9;
  }

  async function updateSettingOnboards() {
    if (store.user.isSalesOrAbove) {
      return;
    }

    if (!hasViewed && !props.department) {
      const variables: updateDepartmentVariables = {
        data: {
          settingOnboards: {
            set: Array.from(
              new Set([...department?.settingOnboards, props.title])
            ),
          },
        },
        where: {
          id: department.id,
        },
      };

      await apiClient(UpdateDepartmentMutation, {
        variables,
      });

      store.updateOrganization();
    }
  }

  return (
    <Link
      to={props.to}
      className="relative block rounded-md border border-b-3 border-borderGray bg-white px-4 pb-4 pt-3"
      onClick={updateSettingOnboards}
    >
      {!hasViewed && props.title !== "Financial" && (
        <div className="absolute -top-3">⭐️</div>
      )}
      <div className="mb-0.5 flex items-center">
        <div className="flex-1 font-bold">{props.title}</div>

        {props.icon && <div>{props.icon}</div>}
      </div>
      <div className="text-sm text-dark">{props.children}</div>
    </Link>
  );
}
